import React from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import MaintenanceCompanyList from './MaintenanceCompanyList';
import { icon } from 'leaflet';

//redux

const MaintenanceCompany = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Empresa de Mantenimiento' links={breadcrumbLinks} icon={'icon-hammer'}/>
					<MaintenanceCompanyList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default MaintenanceCompany;
